var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"radius","need-next":true},on:{"go":_vm.goNext}},[_c('m-map-radius',{attrs:{"selectedType":"radius","is-go":_vm.isGo},on:{"update:isGo":function($event){_vm.isGo=$event},"update:is-go":function($event){_vm.isGo=$event},"updateIsGo":function($event){}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0ed2974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoRadius.vue
// module id = null
// module chunks = 